import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { Formik, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Table, InputGroup } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import { AlphaNumericValidation, NumberValidation, showNotification } from "../../utils/commonFunctions";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { cloud_url } from "../../../Services/Configuration";
import axios from "axios";
import { store } from "../../../App";
import { notification } from "antd";
import ShowAlert from "../../alert";
import { FaFastBackward, FaWallet, FaBalanceScale, FaClipboard, FaRupeeSign, FaRegCreditCard, FaMoneyBill, FaBriefcase } from "react-icons/fa";
import Swal from 'sweetalert2';
import ClassificationHeads from "./ClassificationHeads";


function SalaryJournal() {
  const formReference = useRef();

  const [transactionId, setTransactionId] = useState();

  const [VoucherList, setVoucherList] = useState();
  const [selectedVoucherList, setSelectedVoucherList] = useState([]);
  const [voucher, setVoucher] = useState();
  const [ClassBudget, setClassBudget] = useState([]);
  const [headNamesList, setHeadNamesList] = useState([]);
  const [newRowIndexes, setNewRowIndexes] = useState([]);
  const [data, saveData] = useState([])
  const [rowdata, saveRowData] = useState([]);


  let history = useHistory();


  function isValidNumber(number) {
    return 0 <= number && number <= 10;
  }

  React.useEffect(() => {
    let params = {
      save_flag_Payment_Receipts_Journal: "Journal"
    };

    HousingService.getPaymentReceiptId(params).then((res) => {
      const id = res.data[0].payment_receipt_id;

      setTransactionId(id);
    });

    // HousingService.ClassificationBudget(params).then((res) => {
    //   const id = res.data[0].payment_receipt_id;

    //   setTransactionId(id);
    // });

    HousingService.fetchSalaryJVList().then((res) => {
      setVoucher(res.data);

      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.voucher_id}>
              {item.voucher_name}
            </option>
          );
        });

        setVoucherList(options);
      }
    });

    HousingService.ClassificationBudget().then((res) => {
      setClassBudget(res.data);
      // const sortedData = res.data.sort((a, b) =>
      //   a.classification === "01" ? -1 : a.classification.localeCompare(b.classification)
      // );
      saveRowData(res.data)
      console.log(res.data);
    });
    HousingService.fetchHeadNamesDropdowns().then((res) => {
      if (res.data) {
        let options = res.data.map((item) => ({
          value: item.headid,  // map headid to value
          label: item.heads,   // map heads to label
        }));
        setHeadNamesList(options);
      }
    });

  }, []);

  const displaydescription = (e, setFieldValue) => {
    const { name, value } = e.target;
    setSelectedVoucherList(true);
    setFieldValue(name, value);

    let rec =
      voucher?.find((item) => parseInt(item?.voucher_id) === parseInt(value)) ||
      null;

    let description = "";

    if (rec !== null) {
      description = rec.description;

      hitHeadsApi(value, setFieldValue);
    } else {
      setFieldValue("subHeadList", []);
    }

    setFieldValue("description", description);
  };

  const hitHeadsApi = (voucher_id, setFieldValue) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.fetchJournalVoucherDescription(voucher_id).then((res) => {
      if (res.data) {
        saveData(res.data)
        console.log(res.data)
        // let array = [...res?.data];
        let array = [...(res?.data || [])];
        array.forEach((item) => {
          item["debit"] = "";

          item["credit"] = "";
        });

        setFieldValue("subHeadList", array);
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    });
  };

  const [Credit, setCredit] = useState();

  const [Debit, setDebit] = useState();


  const Listing = (values, j) => {
    let Credit = values?.subHeadList?.reduce(
      (sum, row) => parseFloat(row?.credit || 0) + sum,
      0
    );

    let Debit = values?.subHeadList?.reduce(
      (sum, row) => parseFloat(row?.debit || 0) + sum,
      0
    );

    setCredit(Credit);

    setDebit(Debit);
  };

  const getPdf = async (payment_receipt_id, callback) => {
    try {
      const res = await HousingService.getjournalpdf(payment_receipt_id);
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      window.open(url, "_blank"); // Open the PDF in a new tab or window
      if (callback) {
        callback(); // Call the callback function to reset the form and reload
      }
    } catch (error) {
      console.error("Error getting PDF:", error);
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);

  // const handleFileChange = (event) => {
  //   setSelectedFile(event.target.files[0]);
  // };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["application/pdf", "image/jpeg", "image/jpg", "image/png"]; const maximumSize = 2 * 1024 * 1024;

      if (validTypes.includes(file.type)) {
        if (file.size > maximumSize) { ShowAlert("File Size Exceeds The Limit Of 2 MB Only", "error"); e.target.value = ""; return; }
        setSelectedFile(file);
      }
      else {
        ShowAlert("Only PDF and Image Files Are Allowed", "error"); e.target.value = "";
      }
    }
  };


  const handleUpload = () => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", selectedFile);

      HousingService.fileUploadUrlJV(formData)
        .then((response) => {
          resolve(response.data); // Resolve with the uploaded data
        })
        .catch((error) => {
          resolve(null);
        });
    });
  };
  const today = new Date().toISOString().split('T')[0];




  const subhandleHeadNames = (e, field, values, setFieldValue, index) => {
    field.onChange(e);
    const selectedheadname = e.target.value;
    HousingService.fetchSubHeadName(selectedheadname).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => ({
          value: item.subheadseqid,
          label: item.subheads,
        }));

        setFieldValue(`subHeadList.${index}.subHeadOptions`, options);
      }
    });
  };


  return (
    <>
      <NavigationServicesHeader />

      <Formik
        innerRef={formReference}
        initialValues={{
          payment_receipt_id: transactionId,
          date: "",
          voucher_id: "",
          description: "",
          debit: "",
          credit: "",
          upload_copy: selectedFile,
          subHeadList: []
        }}

        onSubmit={async (values, { resetForm, setFieldError }) => {
          try {
            let debit = values?.subHeadList?.reduce(
              (sum, row) => parseFloat(row?.debit || 0) + sum,
              0
            );
            let credit = values?.subHeadList?.reduce(
              (sum, row) => parseFloat(row?.credit || 0) + sum,
              0
            );

            values.debit = debit;
            values.credit = credit;

            if (debit === 0 || credit === 0) {
              showNotification("warning", "Enter amount before submitting");
              return;
            }
            if (debit !== credit) {
              showNotification("warning", "Debit and Credit should be equal");
              return;
            }

            let formData = { ...values };
            formData["payment_receipt_id"] = transactionId;
            formData["dummy_journal_voucher_heads_Req"] = values?.subHeadList;
            console.log("Payload before file upload:", formData);

            if (!selectedFile) {
              setFieldError("upload_copy", "File is required");
              return;
            }

            const uploadedData = await handleUpload(); // Upload the file
            setUploadedFile(uploadedData); // Store the uploaded data
            formData.upload_copy = uploadedData; // Assign uploaded file data to formData

            Swal.fire({
              text: "Do you want to submit?",
              icon: "question",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
            }).then(async (result) => {
              if (result.isConfirmed) {
                console.log(formData);

                const res = await HousingService.salaryGenerationJournalInsertion(formData);
                if (res?.data?.SCODE === "01") {
                  showNotification("success", "Submitted successfully");
                  await getPdf(formData?.payment_receipt_id, () => {
                    resetForm();
                    window.location.reload();
                  });
                }
                else if (res?.data?.SCODE == "04") {
                  showNotification("warning", res?.data?.SDESC);
                }
                else {
                  showNotification("warning", res?.data?.SDESC);
                }
              }
            });

          } catch (error) {
            console.error("Error uploading file:", error);
            showNotification("error", "File name should not contain symbols or special characters.");
          }
        }}

        validationSchema={Yup.object({
          date: Yup.date().required("Date is required"),
          upload_copy: Yup.mixed().required("File is required"),
          voucher_id: Yup.string().required("Voucher ID is required"),
          dummy_journal_voucher_heads_Req: Yup.array().of(
            Yup.object().shape({
              headname: Yup.string().required("Head Name is required"),
              subheadname: Yup.string().required("Sub Head Name is required"),
              credit: Yup.number().required("Credit amount is required").typeError("Credit amount should be a number"),
              debit: Yup.number().required("Debit amount is required").typeError("Debit amount should be a number")
            })
          )
        })}
      >
        {({ formik, errors, values, touched, setFieldValue, handleSubmit, resetForm, handleChange }) => (
          <Form onSubmit={handleSubmit} onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}>
            <OFMSUI.Container fluid style={{ width: "90%" }}>
              <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                  <div className="inner-herbpage-service-title1">
                    <h1 style={{ marginLeft: "-15px" }}> Salary Journal Voucher </h1>
                  </div>
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                  <button
                    className="btn btn-primary btn-sm"
                    style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }}
                    type="reset"
                    onClick={() => history.goBack()}
                  >
                    <FaFastBackward /> &nbsp;Back
                  </button>
                </OFMSUI.Col>
              </OFMSUI.Row>
            </OFMSUI.Container >
            <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
              <ClassificationHeads />
              <OFMSUI.Row className="p-4">
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                  <label> <b>Transaction Id No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                  <Field
                    value={transactionId}
                    name="payment_receipt_id"
                    className={touched.payment_receipt_id && errors.payment_receipt_id ? "form-control is-invalid" : "form-control"}
                    type="text"
                    maxLength={10}
                    disabled={true}
                  />
                  {touched.payment_receipt_id && errors.payment_receipt_id ? (
                    <div className="invalid-feedback"> {errors.payment_receipt_id} </div>) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                  <label> <b>Date</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>

                  <Field
                    name="date"
                    className={touched.date && errors.date ? "form-control is-invalid" : "form-control"}
                    type="date"
                    max={today}
                    min="2024-01-01"
                  />
                  {touched.date && errors.date ? (<div className="invalid-feedback">{errors.date}</div>) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                  <label> <b>Voucher No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>

                  <Field name="voucher_id">
                    {({ field }) => (
                      <select
                        {...field}
                        onChange={(e) => displaydescription(e, setFieldValue)}
                        className={"form-control" + (errors.voucher_id && touched.voucher_id ? " is-invalid" : "")}
                      >
                        <option value="">--Select--</option>

                        {VoucherList}
                      </select>
                    )}
                  </Field>
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="" >
                  <label> <b>Description</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>

                  <Field
                    name="description"
                    as="textarea"
                    className={touched.description && errors.description ? "form-control is-invalid" : "form-control"}
                    
                  />
                  {touched.description && errors.description ? (<div className="invalid-feedback">{errors.description}</div>) : null}
                </OFMSUI.Col>

              </OFMSUI.Row>
              {selectedVoucherList && (
                <div>
                  <OFMSUI.Row className="p-4">
                    <FieldArray name="subHeadList">
                      {({ insert, remove }) => (
                        <>
                          <Table striped bordered hover>
                            <thead className="fw-bold">
                              <tr className="table_countshead">
                                <td>S.No</td>
                                <td style={{ width: "50%" }}>Heads Name</td>
                                <td style={{ width: "15%" }}>SubHeads Name</td>
                                <td>Debit</td>
                                <td>Credit</td>
                                <td>Action</td>
                              </tr>
                            </thead>
                            <tbody>
                              {values.subHeadList.map((sub, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {newRowIndexes.includes(index) ? (
                                      <Field name={`subHeadList.${index}.headid`}>
                                        {({ field, form }) => (
                                          <select
                                            {...field}
                                            className="form-control"
                                            onChange={(e) =>
                                              subhandleHeadNames(
                                                e,
                                                field,
                                                form.values,
                                                form.setFieldValue,
                                                index
                                              )
                                            }
                                          >
                                            <option value="">Select Head</option>
                                            {headNamesList.map((option) => (
                                              <option key={option.value} value={option.value}>
                                                {option.label}
                                              </option>
                                            ))}
                                          </select>
                                        )}
                                      </Field>
                                    ) : (
                                      // ✅ Existing rows → show plain text only
                                      <span>{values.subHeadList[index].headname}</span>
                                    )}
                                  </td>
                                  <td>
                                    {newRowIndexes.includes(index) ? (
                                      <Field
                                        as="select"
                                        name={`subHeadList.${index}.subheadid`}
                                        className="form-control"
                                      >
                                        <option value="">Select Subhead</option>
                                        {values.subHeadList[index]?.subHeadOptions?.length > 0 ? (
                                          values.subHeadList[index].subHeadOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))
                                        ) : (
                                          <option value="" disabled>No subheads available</option>
                                        )}
                                      </Field>
                                    ) : (
                                      <Field
                                        name={`subHeadList.${index}.subheadname`}
                                        className="form-control"
                                        placeholder="-"
                                        disabled
                                      />
                                    )}
                                  </td>
                                  <td>
                                    <Field
                                      name={`subHeadList.${index}.debit`}
                                      className="form-control"
                                      type="text"
                                      onKeyPress={(e) => NumberValidation(e)}
                                      maxLength={15}
                                      onChange={(e) => {
                                        handleChange(e); // Handle default input changes
                                        setFieldValue(`subHeadList.${index}.credit`, "0");
                                        
                                        // const value = parseFloat(e.target.value || 0); // Parse input value as a number
                                        // const headid = values.subHeadList[index]?.headid; // Get headid for the current subhead item

                                        // console.log("value:", value);
                                        // console.log("headid:", headid);
                                        // console.log("typeof headid:", typeof headid);
                                        // console.log("data:", data);

                                        // if (!data || !Array.isArray(data)) {
                                        //   console.error("Invalid or missing data array");
                                        //   return;
                                        // }

                                        // // Find classification by headid
                                        // const classification = data.find((item) => item.headid === String(headid));

                                        // if (!classification) {
                                        //   console.error(`No classification found for headid: ${headid}`);
                                        //   return;
                                        // }

                                        // console.log("classification:", classification.classification);

                                        // // Skip budget checks for classification '00' and 06
                                        // if (classification.classification === '00' || classification.classification === '06' || classification.classification === '08' || classification.classification === '07') {
                                        //   console.log("No budget limit for classification '00', skipping budget checks.");
                                        //   return;
                                        // }

                                        // if (!ClassBudget || !Array.isArray(ClassBudget)) {
                                        //   console.error("Invalid or missing ClassBudget array");
                                        //   return;
                                        // }

                                        // // Find budget and expenditure for the classification
                                        // const budgetItem = ClassBudget.find((item) => item.classification === classification.classification);
                                        // const budgetAmount = budgetItem?.budget || 0;
                                        // const expenAmount = budgetItem?.expen || 0;

                                        // console.log("Checking budget and expenditure:");
                                        // console.log("Budget:", budgetAmount);
                                        // console.log("Expenditure:", expenAmount);

                                        // // Check if expenditure exceeds or matches the budget
                                        // if (expenAmount >= budgetAmount) {
                                        //   console.log("Budget exceeded or matched, showing alert...");
                                        //   ShowAlert("No Budget Available", "warning").then(() => {
                                        //     setFieldValue(`subHeadList.${index}.debit`, ""); // Clear the debit field
                                        //   });
                                        //   return;
                                        // }

                                        // // Calculate total debits excluding the current item
                                        // const otherDebits = values.subHeadList
                                        //   .filter((sub, idx) => idx !== index && sub.headid === headid)
                                        //   .reduce((sum, sub) => parseFloat(sub.debit || 0) + sum, 0);

                                        // const totalDebit = value + otherDebits + expenAmount;

                                        // console.log("Total Debit:", totalDebit);

                                        // // Check if the total debit exceeds the budget
                                        // if (totalDebit > budgetAmount) {
                                        //   ShowAlert("Budget Limit Exceeded", "warning").then(() => {
                                        //     setFieldValue(`subHeadList.${index}.debit`, ""); // Clear the debit field
                                        //   });
                                        // }
                                      }}


                                    />
                                  </td>


                                  <td>
                                    <Field
                                      name={`subHeadList.${index}.credit`}
                                      className="form-control"
                                      type="text"
                                      onKeyPress={(e) => NumberValidation(e)}
                                      maxLength={15}
                                      onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue(`subHeadList.${index}.debit`, "0"); // Reset debit to 0
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      onClick={() => remove(index)}
                                      className="btn btn-danger"
                                      style={{ fontSize: "0.6rem", width: "100px" }}
                                    >
                                      Remove
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              {values.subHeadList.length > 0 && (
                                <>
                                  <tr>
                                    <td colSpan="3" style={{ textAlign: "right" }}>
                                      Total:
                                    </td>
                                    <td>
                                      {/* Calculate total debit */}
                                      {values.subHeadList.reduce(
                                        (acc, curr) => acc + (parseFloat(curr.debit) || 0),
                                        0
                                      )}
                                    </td>
                                    <td>
                                      {/* Calculate total credit */}
                                      {values.subHeadList.reduce(
                                        (acc, curr) => acc + (parseFloat(curr.credit) || 0),
                                        0
                                      )}
                                    </td>
                                    <td></td>
                                  </tr>
                                </>
                              )}
                            </tfoot>
                          </Table>

                          <div
                            style={{
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                              textAlign: "initial",
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => {
                                insert(values.subHeadList.length, {
                                  headid: "",
                                  subheadid: "",
                                  debit: "",
                                  credit: "",
                                });
                                setNewRowIndexes([...newRowIndexes, values.subHeadList.length]);
                              }}
                              className="btn btn-primary"
                              style={{ borderRadius: '8px' }} // Adjust the value for more or less curvature
                            >
                              Add Heads
                            </button>

                          </div>
                        </>
                      )}
                    </FieldArray>

                  </OFMSUI.Row>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="m-2">
                    <div>
                      <label> <b>File Upload (File name should not contain symbols or special characters.)</b> <span className="text-danger">*</span> </label>
                      <InputGroup>
                        <input
                          type="file"
                          name="upload_copy"
                          onChange={(event) => {
                            handleFileChange(event);
                            setFieldValue("upload_copy", event.target.files[0]);
                          }}
                          className="form-control"
                          accept=".pdf"
                        />
                      </InputGroup>
                      <ErrorMessage name="upload_copy" component="div" className="text-danger" />
                    </div>
                  </OFMSUI.Col>
                </div>
              )}
              <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
                  <button type="submit" className="btn btn-success">Submit</button>
                </OFMSUI.Col>
              </OFMSUI.Row>
            </OFMSUI.Container>


          </Form>
        )}
      </Formik>

    </>
  );
}

export default SalaryJournal;
